import React, { FC, useCallback } from 'react';
import { Button, confirm, notification, useMe } from 'src/common';
import { useTranslation } from 'react-i18next';
import { ICompanyUser } from 'src/models/company/Users/types';
import modalStyles from 'src/common/Modal/index.module.scss';
import { trackUserInviteByAdmin } from 'src/segment/events';
import { useSendInvite } from 'src/models/admin/hooks';

interface IProps {
  user: ICompanyUser;
}

export const InviteUserButton: FC<IProps> = ({ user }) => {
  const { email, name, lastName, role, inviteSent } = user;

  const { t } = useTranslation();
  const [sendInvite] = useSendInvite();
  const { data: me } = useMe();

  const confirmHandler = useCallback(() => {
    confirm.confirm({
      title: t('Teammates.inviteConfirmText'),
      content: t('Teammates.inviteConfirmDescription'),
      okText: t('Common.yes'),
      cancelText: t('Common.no'),
      className: modalStyles.confirmModal,
      centered: true,
      onOk() {
        sendInvite({ variables: { email } })
          .then(() => {
            trackUserInviteByAdmin({
              email,
              name,
              lastName,
              role,
              invitedByRole: String(me?.company?.pricePlan)
            });
          })
          .catch(() => {
            notification.error({
              message: t('Teammates.employeeHasNotAdded'),
              description: t('Common.unknownErrorDesc')
            });
          });
      }
    });
  }, [email, lastName, me, name, role, sendInvite, t]);

  return (
    <Button type={inviteSent ? 'default' : 'primary'} onClick={confirmHandler}>
      {t(inviteSent ? 'Teammates.sendAgain' : 'Teammates.sendInvite')}
    </Button>
  );
};

export default InviteUserButton;
